import { type TFunction } from "i18next";
import { z } from "zod";

export const MAX_TEXT_LENGTH = 1000;

export const rejectSchema = (t: TFunction) =>
  z.object({
    files: z.any().optional(),
    internalNotes: z
      .string()
      .max(
        1000,
        t("form-validation.max-length", {
          label: t("vessel-call.common.internal-notes"),
          max: 1000,
        }),
      )
      .optional(),
    rejectionReason: z
      .string()
      .max(
        1000,
        t("form-validation.max-length", {
          label: t("vessel-call.common.external-notes"),
          max: 1000,
        }),
      )
      .min(1, t("form-validation.mandatory", { label: t("vessel-call.common.external-notes") })),
  });

export type RejectSchema = z.infer<ReturnType<typeof rejectSchema>>;
